document.querySelectorAll('a[href^="#"]:not([href="#"]):not(.skip-link):not(.ignore-scroll)').forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();

    const target = event.currentTarget.getAttribute('href').slice(1);
    const element = document.getElementById(target);
    if (element) {
      const yOffset = -80;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
  
      window.scrollTo({
        top: y,
        behavior: "smooth"
      });
    }
  })
})
